// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".props-img-wrap[data-v-1c91784b]{font-size:0}", ""]);
// Exports
module.exports = exports;
